<template>
  <div>
    <GeneralSettings></GeneralSettings>
    <ColorSelector :primary="primaryColor" :background="backgroundColor" :footer="footerColor" @updateColor="updateColor"></ColorSelector>
    <hr />
    <HeaderImageSelector :url="header_url" @changeHeaderUrl="changeHeaderUrl"></HeaderImageSelector>
    <hr />
    <FooterImageSelector :url="footer_url" @changeFooterUrl="changeFooterUrl"> </FooterImageSelector>
    <hr />
    <SponsorImageSelector :url="sponsor_url" @changeSponsorUrl="changeSponsorUrl"> </SponsorImageSelector>
    <hr />
    <ExtraLinksHomepage :extra_links="extra_links"></ExtraLinksHomepage>
    <hr />
    <FeaturedContentBuilder :featured_content="featured_content"></FeaturedContentBuilder>
    <hr />
    <b-button class="button_save_admin" @click="updateAdminStyle">Sauvegarder la configuration</b-button>
  </div>
</template>

<script>
import axios from "axios";
import ColorSelector from "@/components/Admin_tab/ColorSelector.vue";
import GeneralSettings from "@/components/Admin_tab/GeneralSettings.vue";
import HeaderImageSelector from "@/components/Admin_tab/HeaderImageSelector.vue";
import SponsorImageSelector from "@/components/Admin_tab/SponsorImageSelector.vue";
import FooterImageSelector from "@/components/Admin_tab/FooterImageSelector.vue";
import ExtraLinksHomepage from "@/components/Admin_tab/ExtraLinksHomepage.vue";
import FeaturedContentBuilder from "@/components/Admin_tab/FeaturedContentBuilder.vue";
export default {
  components: { ColorSelector, GeneralSettings, HeaderImageSelector, SponsorImageSelector, FooterImageSelector, ExtraLinksHomepage, FeaturedContentBuilder },
  data() {
    return {
      primaryColor: "#F29200",
      backgroundColor: "#e9f1f3",
      footerColor: "#2f3a45",
      header_url: "https://sportips.fr/race/uploads/topbar_bg.jpg",
      footer_url: "https://sportips.fr/race/uploads/topbar_bg.jpg",
      sponsor_url: "https://sportips.fr/race/uploads/topbar_bg.jpg",
      extra_links: [],
      featured_content: [],
    };
  },
  watch: {
    extra_links() {
      this.$store.state.admin.extra_links = this.extra_links;
    },
    featured_content() {
      this.$store.state.admin.featured_content = this.featured_content;
    },
  },
  methods: {
    updateColor(c) {
      if (c.type === "primary") {
        this.primaryColor = c.value;
        this.$store.state.admin.primary_color = c.value;
      } else if (c.type === "background") {
        this.backgroundColor = c.value;
        this.$store.state.admin.background_color = c.value;
      } else if (c.type === "footer") {
        this.footerColor = c.value;
        this.$store.state.admin.footer_color = c.value;
      }
    },
    changeHeaderUrl(url) {
      this.header_url = url;
      this.$store.state.admin.header_url = url;
    },
    changeSponsorUrl(url) {
      this.sponsor_url = url;
      this.$store.state.admin.sponsor_url = url;
    },
    changeFooterUrl(url) {
      this.footer_url = url;
      this.$store.state.admin.footer_url = url;
    },

    updateAdminStyle() {
      var _this = this;
      var data = new FormData();

      var extra_links = JSON.stringify(this.extra_links);
      var featured_content = JSON.stringify(this.featured_content);
      data.append("id_module", this.$store.state.module.id);
      data.append("action", "style");
      data.append("primary_color", this.$store.state.admin.primary_color);
      data.append("background_color", this.$store.state.admin.background_color);
      data.append("footer_color", this.$store.state.admin.footer_color);
      data.append("header_url", this.$store.state.admin.header_url);
      data.append("sponsor_url", this.$store.state.admin.sponsor_url);
      data.append("footer_url", this.$store.state.admin.footer_url);
      data.append("allow_gpx_download", this.$store.state.admin.allow_gpx_download);

      data.append("extra_links", extra_links);
      data.append("featured_content", featured_content);
      axios.post(this.$store.state.base_url + "/admin/update.php", data).then(function (response) {});
    },
  },
  created() {
    this.primaryColor = this.$store.state.admin.primary_color;
    this.backgroundColor = this.$store.state.admin.background_color;
    this.footerColor = this.$store.state.admin.footer_color;
    this.header_url = this.$store.state.admin.header_url;
    this.sponsor_url = this.$store.state.admin.sponsor_url;
    this.footer_url = this.$store.state.admin.footer_url;
    this.extra_links = this.$store.state.admin.extra_links;
    this.featured_content = this.$store.state.admin.featured_content;
    this.$forceUpdate();
  },
};
</script>

<style lang="sass" scoped>
</style>